'use client';

import { useLiveQuery } from '@sanity/preview-kit';
import { FC } from 'react';
import Theme from '@/src/components/screens/theme/Theme';
import themeQuery from '@/src/lib/queries/themeQuery';
import { ITheme } from '@/src/lib/types/themeInterface';

interface PreviewThemePageProps {
  data: ITheme;
  slug: string;
}

const PreviewThemePage: FC<PreviewThemePageProps> = ({ data, slug }) => {
  const [themeData] = useLiveQuery(data, themeQuery(slug));

  return <Theme theme={themeData} />;
};

export { PreviewThemePage };
